export const LANGUAGE_EN = 'en';
export const LANGUAGE_DE = 'de';

export const LANGUAGES = [LANGUAGE_EN, LANGUAGE_DE];

export const DEFAULT_LANGUAGE = LANGUAGE_DE;
